import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function HotArticles() {
  const hotArticles = articles.filter((a) => a.isHot);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              热门文章
            </h2>
            <p className="text-sm text-foreground-600 mt-1">
              最受彩民关注的热门资讯
            </p>
          </div>
          <Link
            to="/category/wanfa-guize"
            className="text-sm text-accent-600 font-medium hover:text-accent-700 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {hotArticles.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}